module.exports = __webpack_public_path__ + "static/img/sort6.89f4b6a3.png";